import { BrowserRouter } from "react-router-dom";
import Spinner from "./components/shared/spinner.jsx";
import Sidebar from "./components/layouts/sidebar/sidebar.jsx";
import { useEffect } from "react";

function  App({ nonce }: { nonce: string }) {

  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute("nonce", nonce); 
    document.body.appendChild(script);
  }, [nonce]);

  return (
    <div className="App">
    <BrowserRouter>
    <Sidebar/>
    </BrowserRouter>
    <div className="divSpinner" style={{ display: "none" }}><Spinner /></div>
  </div>
  );
}

export default App;
